// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"9ab64e1d","325":"649d9649","381":"299b6bef","679":"3564c25e"}[chunkId] + ".chunk.css";
};